<div class="rmpWrapper">
  <div class="rmpVideoContainer">
    <div id="rmpPlayer" #playerElement>&nbsp;</div>
  </div>

  @if (media) {
    <h2 class="rmpVideoTitle">{{media.contentTitle}}</h2>
    <div class="rmpVideoDescription" [innerHTML]="media.contentDescription"></div>
  }
</div>

<div #scriptElement></div>
